import classNames from "classnames";

import { Component } from "react";
import { bsClass, getClassSet, splitBsProps } from "./utils/bootstrapUtils";

class InputGroupButton extends Component {
  render() {
    const { className, ...props } = this.props;
    const [bsProps, elementProps] = splitBsProps(props);

    const classes = getClassSet(bsProps);

    return (
      <span
        {...elementProps}
        className={classNames(className, classes)}
      />
    );
  }
}

export default bsClass("input-group-btn", InputGroupButton);
